<template lang="pug">
  .funnel-layout
    div(:class="$vuetify.breakpoint.smAndDown ? '' : 'mx-2'")
      v-card.pt-6.pb-2(ref="mainContainer" width="100%" flat :outlined="$vuetify.breakpoint.smAndDown ? false : true")
        v-col.pa-0
          vue-funnel-graph(v-if="ready" :width="width" :height="height" :labels="labels"
          :values="values" :colors="colors" :direction="direction"
          :gradient-direction="gradientDirection"
          :animated="false" :display-percentage="true" style="font-family:Inter")
          vue-funnel-graph.mt-n2(v-if="ready" :width="width" :height="0" :labels="labels2"
          :values="values2" :colors="colors2" :display-percentage="false" style="font-family:Inter")
</template>

<script>
export default {
  name: 'DashboardFunnel',
  props: ['metrics'],
  data() {
      return {
          ready: false,
          labels: [this.$t('views'), this.$t('leads'), this.$t('sales')],
          values: [0, 0, 0],
          colors: [this.$vuetify.theme.themes[this.$theme].info200T16, this.$vuetify.theme.themes[this.$theme].info200T40, this.$vuetify.theme.themes[this.$theme].info200],
          direction: 'horizontal',
          gradientDirection: 'horizontal',
          height: 0,
          width: 0,
          labels2: ['', '', ''],
          values2: ['', '', ''],
          colors2: [
              ['#FFB178', '#FF3C8E'], // color set for "Impressions" segment
              ['#A0BBFF', '#EC77FF'], // color set for "Add To Cart" segment
              ['#A0F9FF', '#7795FF']  // color set for "Buy" segment
          ],
      };
  },
  watch: {
    metrics: {
      handler (val) {
        if (val) {
          this.values.splice(0, 1, val['clicks']['total_current'])
          this.values.splice(1, 1, val['leads']['total_current'])
          this.values.splice(2, 1, val['paid_leads']['total_current'])
          this.values2.splice(1, 1, `${this.$currency.symbol} ${this.kFormatter(val['sales_opportunity']['total_current'] / this.$currency.multiplier)}`)
          this.values2.splice(2, 1, `${this.$currency.symbol} ${this.kFormatter(val['sales']['total_current'] / this.$currency.multiplier)}`)
          this.labels2.splice(1, 1, this.calcDiff(val['sales_opportunity']['total_current'], val['sales_opportunity']['total_previous']))
          this.labels2.splice(2, 1, this.calcDiff(val['sales']['total_current'], val['sales']['total_previous']))
        }
      },
      deep: true
    }
  },
  mounted () {
    this.width = this.$refs.mainContainer.$el.clientWidth
    let height = this.width / 1.8
    if (height > 180) {
      this.height = 180
    } else {
      this.height = height
    }
    this.ready = true
  },
  methods: {
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    },
    calcDiff (currentAmount, previousAmount) {
      if (currentAmount == previousAmount) {
        return ''
      }
      let displayAmount = Math.abs(previousAmount - currentAmount) / this.$currency.multiplier  // Cent to RM
      displayAmount = this.kFormatter(displayAmount)  // 1200 to 1.2k
      if (currentAmount >= previousAmount) {
        return `⬆ ${this.$currency.symbol} ${displayAmount}`
      } else {
        return `⬇ ${this.$currency.symbol} ${displayAmount}`
      }
    }
  }
}
</script>

<style>
@media (max-width : 600px) {
  .label__value {
    /*text-align: center;*/
    font-size: 1.2em !important;
  }
}
.svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label:not(:first-child) {
  border-left: 1px solid var(--v-primary300);
}
.svg-funnel-js__container {
  padding-top: 8px;
}
</style>
